import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b496aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-settings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_AccountInformation = _resolveComponent("AccountInformation")!
  const _component_CustomerDetails = _resolveComponent("CustomerDetails")!
  const _component_AccountPassword = _resolveComponent("AccountPassword")!
  const _component_AccountPreferences = _resolveComponent("AccountPreferences")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_BaseSpinner, {
          key: 0,
          size: 40
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_AccountInformation, { customer: _ctx.user }, null, 8, ["customer"]),
          _createVNode(_component_CustomerDetails, { user: _ctx.user }, null, 8, ["user"]),
          _createVNode(_component_AccountPassword),
          (_ctx.user.type === _ctx.UserType.Customer)
            ? (_openBlock(), _createBlock(_component_AccountPreferences, {
                key: 0,
                customer: _ctx.user
              }, null, 8, ["customer"]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}